<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="新增活动"
    >
        <div class="container">
            <el-form
                ref="addForm"
                :rules="rules"
                :model="addForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动名称"
                            size="small"
                            prop="title"
                        >
                            <el-input
                                clearable
                                placeholder="请输入活动名称"
                                size="small"
                                v-model="addForm.title"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="活动地点"
                            size="small"
                            prop="address"
                        >
                            <el-input
                                clearable
                                placeholder="请输入活动地点"
                                size="small"
                                v-model.number="addForm.address"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="联系人"
                            size="small"
                            prop="contact_name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入联系人"
                                maxlength="30"
                                size="small"
                                v-model="addForm.contact_name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="联系电话"
                            size="small"
                            prop="contact_phone"
                        >
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                maxlength="30"
                                size="small"
                                v-model.number="addForm.contact_phone"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动起始时间"
                            size="small"
                            prop="time"
                        >
                            <el-date-picker
                                v-model="addForm.time"
                                type="datetimerange"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="主办方"
                            size="small"
                            prop="sponsor"
                        >
                            <el-input
                                clearable
                                placeholder="请输入主办方"
                                maxlength="30"
                                size="small"
                                v-model="addForm.sponsor"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                        <el-form-item
                            label="活动结束时间"
                            size="small"
                            prop="end_time"
                        >
                            <el-date-picker
                                v-model="addForm.end_time"
                                type="datetime"
                                placeholder="选择结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                format="yyyy-MM-dd HH:mm:ss"
                                default-time="00:00:00"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col> -->
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="活动封面"
                            size="small"
                            prop="cover"
                        >
                            <imgUpload2
                                :width="'120'"
                                :height="'120'"
                                :limit="1"
                                :multiple="false"
                                name="img"
                                :clean="clean"
                                @imagesChange="imagesChange"
                            >
                                <p class="words">
                                    *仅支持jpg、png格式的图片上传，且文件大小不大于1M
                                </p>
                            </imgUpload2>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="活动内容"
                            size="small"
                            prop="content"
                        >
                            <vue-tinymce
                                v-if="addVisible"
                                v-model="addForm.content"
                                :setting="setting"
                                :setup="setup"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="addVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as api from "@/http/api.js";
import * as oaApi from "@/http/oaApi.js";
import * as publicApi from "@/http/publicApi.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            addForm: {
                title: "",
                address: "",
                content: "",
                sponsor: "",
                contact_name: "",
                contact_phone: "",
                time: [],
                start_time: "",
                end_time: "",
                cover: ""
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "请输入活动名称",
                        trigger: "blur"
                    }
                ],
                address: [
                    {
                        required: true,
                        message: "请输入活动地点",
                        trigger: "blur"
                    }
                ],
                content: [
                    {
                        required: true,
                        message: "请输入活动内容",
                        trigger: "blur"
                    }
                ],
                sponsor: [
                    {
                        required: true,
                        message: "请输入主办方",
                        trigger: "blur"
                    }
                ],
                contact_name: [
                    {
                        required: true,
                        message: "请输入联系人",
                        trigger: "blur"
                    }
                ],
                contact_phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur"
                    },
                    {
                        pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
                        message: "手机号格式有误"
                    }
                ],
                time: [
                    {
                        required: true,
                        message: "请选择活动起始时间",
                        trigger: "blur"
                    }
                ],
                cover: [
                    {
                        required: true,
                        message: "请选择活动封面",
                        trigger: "blur"
                    }
                ]
            },
            // 用于清除上次新增的图片
            clean: false
        };
    },
    components: {
        imgUpload2: () => import("@/comon/components/imgUpload2.vue")
    },
    computed: {
        ...mapState({
            setting: state => state.index.setting,
            pickerOptions: state => state.index.pickerOptions
        })
    },
    props: {
        addVisible: Boolean
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (!newValue && this.clean) {
                    this.clean = false;
                }
            }
        }
    },
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["addForm"].validate(valid => {
                if (valid) {
                    this.addForm.start_time = this.addForm.time[0];
                    this.addForm.end_time = this.addForm.time[1];
                    oaApi.activityList(this.addForm, "post").then(res => {
                        if (res.code == 200) {
                            //console.log(res);
                            this.$parent.activityList();
                            this.closeDialog();
                            this.$message.success("新增成功!");
                        }
                    });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:addVisible", false);
            this.clean = true;
            this.$refs["addForm"].resetFields();
            this.$refs["addForm"].clearValidate();
        },
        /**
         * 图片上传组件,上传之后的回调
         */
        imagesChange(imgList) {
            //console.log(imgList);
            let arr = [];
            imgList.map(item => {
                arr.push(item);
            });
            this.addForm.cover = arr.toString();
            // 去除相应的必填提示语
            this.$refs["addForm"].clearValidate("cover");
        },
        tinymceChange(e) {
            console.log(e);
        },
        /**
         * 富文本失去焦点
         */
        setup(editor) {
            editor.on("blur", e => {
                this.$refs["addForm"].clearValidate("content");
            });
            editor.on("KeyDown", e => {
                if ((e.keyCode == 8 || e.keyCode == 46) && editor.selection) {
                    // delete & backspace keys
                    var selectedNode = editor.selection.getNode(); // get the selected node (element) in the editor
                    if (selectedNode && selectedNode.nodeName == "IMG") {
                        publicApi
                            .delFile(
                                {
                                    image_url: selectedNode.src
                                },
                                "post"
                            )
                            .then(res => {
                                if (res.code == 200) {
                                }
                            })
                            .catch(err => {
                                return false;
                            });
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.add {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>
